'use client';

import { useTranslations } from 'next-intl';
import { toasterApi } from '../../toast/ToastProvider';
import { SettingsDangerSection } from '../../settings/SettingsDangerSection';

export type ExternalNetworkDangerSettingsProps = {
  surfaceName: string;
  isDeleting: boolean;
  onDelete: () => Promise<void>;
  onDeleted: () => void;
};

export function ExternalNetworkDangerSettings({
  surfaceName,
  isDeleting,
  onDelete,
  onDeleted,
}: ExternalNetworkDangerSettingsProps) {
  const t = useTranslations(
    'designSystem.networkSettings.externalSettings.danger',
  );
  const tCommon = useTranslations('designSystem.common');

  const handleDelete = async () => {
    try {
      await onDelete();
    } catch (error: unknown) {
      console.error(new Error('Failed to delete external network'), error);
      toasterApi.error({ title: t('deleteError') });

      return;
    }

    toasterApi.success({ title: t('deleteScheduled') });
    onDeleted();
  };

  return (
    <SettingsDangerSection
      rowLabel={t('deleteSurface')}
      actionLabel={t('deleteSurface')}
      warningTitle={t('warningTitle')}
      warningDescription={t('description')}
      confirmTitle={t('confirmTitle')}
      confirmDescription={t('confirmDescription', { name: surfaceName })}
      confirmText={t('confirmText')}
      cancelText={tCommon('cancel')}
      onAction={handleDelete}
      loading={isDeleting}
    />
  );
}
